module.exports = __webpack_public_path__ + "media/components/app-store/static/s2-9732acdcbdcb4ba8c8e605182969e8f8.png";